import {
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Profile } from '@app/profile/profile';

import { TabRouterLessNavigationItem } from '@app/navigation/navigation';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dgx-profile-social-modal',
  templateUrl: './profile-social-modal.component.html',
})
export class ProfileSocialModal implements OnInit {
  @Input() public ownerIsViewing: boolean;
  @Input() public profile: Profile;
  @Input() public defaultTab: string;

  public i18n = this.translateService.instant([
    'Core_Following',
    'Core_Followers',
    'Core_Groups',
    'Core_Cancel',
  ]);

  public tabList: TabRouterLessNavigationItem[];
  public selectedTab: string;

  constructor(
    private translateService: TranslateService,
    private activeModal: NgbActiveModal
  ) {}

  public ngOnInit(): void {
    this.selectedTab = this.defaultTab;
    this.tabList = [
      {
        name: this.i18n.Core_Following,
        nameId: 'following',
      },
      {
        name: this.i18n.Core_Followers,
        nameId: 'followers',
      },
      {
        name: this.i18n.Core_Groups,
        nameId: 'groups',
      },
    ];
  }

  public switchTab(tabName: string): void {
    this.selectedTab = tabName;
  }

  public closeModal(): void {
    this.activeModal.close();
  }
}
